
import { SITE_URL } from '@/api/config'

export default {
  name: 'chart',

  data() {
    return {
      urlchart: ''
    }
  },
  created() {
    this.setHeightIframechart()
  },

  methods: {
    setHeightIframechart() {
      this.urlchart = this.iframeurlchart()
    },
    iframeurlchart() {
      var iframurlchart = SITE_URL + 'won-focus-chart'
      if ( this.$store.state.appsetting.panaray ) {
        iframurlchart =
					iframurlchart +
					'?e=' +
					this.$store.state.appsetting.encemail +
					'&t=' +
					this.$store.state.appsetting.theme
      }
      return iframurlchart
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/chart.js